import React, { Component } from "react";

class BottomToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 200) {
      this.setState({ show: true });
    } else {
      this.setState({ show: false });
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  render() {
    const { show } = this.state;
    return (
      <div
        className="bottomtotop"
        style={{
          display: show ? "block" : "none",
        }}
        onClick={this.scrollToTop}
      >
        <i className="fa fa-chevron-right" />
      </div>
    );
  }
}

export default BottomToTop;
